export function homePathForRole(role: string | undefined): string {
    if (
        role === 'owner_admin' ||
        role === 'guest_admin' ||
        role === 'owner_user' ||
        role === 'admin'
    ) {
        return '/dashboard';
    }
    if (role === 'guest_user' || role === 'guest_department_admin') {
        return '/viewExperiences/all';
    }
    if (role === 'external_attendee_user') {
        return '/reservations';
    }
    if (role?.includes('contractor')) {
        return '/jobs';
    }
    return '/users';
}
